import * as PIXI from 'pixi.js';
import { style } from '@/constants';
import PianoUtil from '@/util/piano-util';
import { pulse } from '@/util/tween';

export class PixiPiano extends PIXI.Sprite {
    boundaries
    PIANO_HEIGHT
    PIANO_WIDTH
    WHITE_KEY_COLOR
    BLACK_KEY_COLOR
    BORDER
    HIGHLIGHT_TINT

    constructor(
        {
            PIANO_WIDTH = 600,
            PIANO_HEIGHT = 150,
            WHITE_KEY_BORDER_COLOR = 0x333333,
            WHITE_KEY_COLOR = 0xFFFFFF,
            showKeyLabels = false,
            overrideKeyLabels = [],
            BLACK_KEY_COLOR = 0x000000,
            PIANO_HIGHLIGHT_HEIGHT = PIANO_HEIGHT,
            BORDER = 1,
            HIGHLIGHT_TINT = 0xFF0000,
            boundaries = { min: 0, max: 88 },
        } = {}
    ) {
        super(PIXI.Texture.WHITE);
        this.anchor.set(0.5, 0.5);
        const whites = PianoUtil.whiteKeysBetween(boundaries.min, boundaries.max);
        this.keyWidth = Math.trunc( (PIANO_WIDTH - BORDER * whites) / whites);
        this.showKeyLabels = showKeyLabels;
        this.overrideKeyLabels = overrideKeyLabels;
        this.boundaries = boundaries;
        this.PIANO_HEIGHT = PIANO_HEIGHT;
        this.PIANO_WIDTH = PIANO_WIDTH;
        this.WHITE_KEY_COLOR = WHITE_KEY_COLOR;
        this.BLACK_KEY_COLOR = BLACK_KEY_COLOR;
        this.PIANO_HIGHLIGHT_HEIGHT = PIANO_HIGHLIGHT_HEIGHT;
        this.BORDER = BORDER;
        this.HIGHLIGHT_TINT = HIGHLIGHT_TINT;
        const { min, max } = boundaries;
        const piano = new PIXI.Graphics();

        piano.width = PIANO_WIDTH;
        piano.height = PIANO_HEIGHT;

        let x = -this.PIANO_WIDTH / 2, count = 0;
        const keysToRender = { white: [], black: [] };
        this.addChild(piano);
        const keyWidth = this.keyWidth;

        for (let i = min; i <= max; i++) {
            const isBlackKey = PianoUtil.isBlackKey(i);

            let width = isBlackKey ? keyWidth / 2 : keyWidth;
            let height = isBlackKey ? PIANO_HEIGHT * 0.7 : PIANO_HEIGHT;
            if (isBlackKey) {
                keysToRender.black.push({ x, y: 0, width, height, keyNumber: i });
            } else {
                keysToRender.white.push({ x, y: 0, width, height, keyNumber: i });
                x += width + BORDER;
                count++;
            }
        }
        keysToRender.white.forEach(({ x, y, width, height, keyNumber }) => {
            piano.lineStyle(3, WHITE_KEY_BORDER_COLOR, 1);
            piano.beginFill(WHITE_KEY_COLOR);
            piano.drawRect(x, y, width, height);
            piano.endFill();

            if (this.showKeyLabels) {
                // add note name label
                let labelText = (PianoUtil.note(keyNumber) + '').toUpperCase();
                if (this.overrideKeyLabels.length) {
                    labelText = this.overrideKeyLabels[keyNumber - this.boundaries.min];
                }
                const label = new PIXI.Text(labelText, {
                    ...style,
                    fontSize: 16,
                    align: 'center',
                    fill: ['0x000000']
                });
                label.x = x + keyWidth / 2 - 5;
                label.y = 10;
                this.addChild(label);
            }
        })

        keysToRender.black.forEach(({ x, y, width, height, keyNumber }) => {
            piano.lineStyle(0);
            piano.beginFill(BLACK_KEY_COLOR);
            piano.drawRect(x - width / 2, y, width, height);
            piano.endFill();
            if (this.showKeyLabels) {
                let labelText = (PianoUtil.note(keyNumber) + '').toUpperCase();
                if (this.overrideKeyLabels.length) {
                    labelText = this.overrideKeyLabels[keyNumber - this.boundaries.min];
                }
                const label = new PIXI.Text(labelText, {
                    ...style,
                    fontSize: 16,
                    align: 'center',
                    fill: ['0xCCCCCC']
                });
                label.x = x - keyWidth * 0.4 /2;
                label.y = -24;
                this.addChild(label);
            }
        });

        // if (config.renderer.pixi.judgementLineShow) {
        //     const judgementLinePosition = -config.renderer.pixi.judgementLinePositionPx;
        //     const judgementLineWidth = config.renderer.pixi.judgementLineWidthPx;
        //     // judgement line
        //     piano.lineStyle(0);
        //     piano.beginFill(0x00ff00);
        //     piano.drawRect(PADDING, judgementLinePosition, PIANO_WIDTH, judgementLineWidth);
        //     piano.endFill();
        //     // show PRE
        //     const PRE_HEIGHT_PX = config.engine.pre/1000 * PX_PER_SECOND;
        //     piano.beginFill(0x0000ff);
        //     piano.drawRect(PADDING, judgementLinePosition-PRE_HEIGHT_PX, PIANO_WIDTH, judgementLineWidth);
        //     piano.endFill();
        //      // show POST
        //      const POST_HEIGHT_PX = config.engine.post/1000 * PX_PER_SECOND;
        //      piano.beginFill(0xFF0000);
        //      piano.drawRect(PADDING, judgementLinePosition + POST_HEIGHT_PX, PIANO_WIDTH, judgementLineWidth);
        //      piano.endFill();
        // }
        this.initHighlights();
    }

    initHighlights() {
        const { min, max } = this.boundaries;
        const highlights = {};
        let x = -this.PIANO_WIDTH/2;
        for (let i = min; i <= max; i++) {
            const highlight = new PIXI.Sprite(PIXI.Texture.WHITE);//PIXI.Sprite.from('public/images/gradient.png');
            highlight.anchor.set(0.5, 0.5);
            highlight.alpha = 0.3;
            highlight.angle = 180;
            const isBlackKey = PianoUtil.isBlackKey(i);
            if (!isBlackKey) {
                highlight.x = x;
                highlight.width = this.keyWidth;
                highlight.height = this.PIANO_HIGHLIGHT_HEIGHT;
                x += (this.BORDER + this.keyWidth);
            } else {
                highlight.width = this.keyWidth / 2;
                highlight.x = x - highlight.width / 2;
                highlight.height = this.PIANO_HIGHLIGHT_HEIGHT * 0.73;
            }
            highlight.x += highlight.width/2;
            highlight.y = this.PIANO_HEIGHT - highlight.height/2;
            this.addChild(highlight);
            highlight.visible = false;
            highlights[i] = highlight;
            highlight.opacity = 0.2;
            highlight.tint = this.HIGHLIGHT_TINT;
            pulse(highlight, 200)
        }
        this.highlights = highlights;
    }

    clearHighlights() {
        Object.keys(this.highlights).forEach(k => this.highlights[k].visible = false);
    }

    setHighlightColor(colorHex) {
        Object.keys(this.highlights).forEach(k => this.highlights[k].tint = colorHex);
    }

    highlightNote(number, noteOn = true) {
        (this.highlights[number] || {}).visible = noteOn;
    }
}